import { Injectable, Logger } from '@nestjs/common';
import { Cron } from '@nestjs/schedule';
import { PrismaService } from '@cart/api-data-access';
import { EmailService } from './email.service';

// Weekly digest of each user's current wishlist — no new schema needed
// (unlike price-drop/back-in-stock, which need a snapshot to diff against).
// Same one-@Cron-method-per-service shape as DemoCleanupService/
// ImageTrashPurgeService, since no queue infrastructure exists yet.
@Injectable()
export class WishlistReminderService {
  private readonly logger = new Logger(WishlistReminderService.name);

  constructor(
    private readonly prisma: PrismaService,
    private readonly emailService: EmailService
  ) {}

  @Cron('0 9 * * 1')
  async sendReminders(): Promise<void> {
    const items = await this.prisma.wishlistItem.findMany({
      where: { isActive: true },
      include: {
        user: { select: { id: true, name: true, email: true } },
        product: { select: { name: true } },
      },
    });

    const byUser = new Map<string, { name: string; email: string; productNames: string[] }>();

    for (const item of items) {
      const existing = byUser.get(item.userId);
      if (existing) {
        existing.productNames.push(item.product.name);
      } else {
        byUser.set(item.userId, {
          name: item.user.name,
          email: item.user.email,
          productNames: [item.product.name],
        });
      }
    }

    let sent = 0;
    for (const { name, email, productNames } of byUser.values()) {
      await this.emailService.sendTemplated('wishlist_reminder', email, {
        customerName: name,
        itemsList: productNames.join(', '),
      });
      sent += 1;
    }

    if (sent > 0) {
      this.logger.log(`Sent wishlist reminder to ${sent} user(s)`);
    }
  }
}
